const state = {
    fieldComponents: [],
    form: {},
    originalForm: {},
    formData: {},
    saveFormData: {},
    formPages: [],
    formFields: [],
    totalPages: 0,
    currentPage: 0,
    formFieldBlacklist: [
        'pageTitle',
        'pageBreak',
        'imageField'
    ],
    currentGroup: {},
    currentField: {},
    rulesModal: {
        visible: false,
        title: "",
        message: "",
        ok: "",
        cancel: "",
        group: {}
    },
    checkRulesTimeout: null,
    checkRulesTimeoutWait: 1000,
    changingPage: false,
    changingPageForward: true,
    navigationActive: true,
    frontend: false,
    frontendData: [],
    formReference: null,
    elementCount: {},
    getExistingSignature: '',
    saveReusableSignature: '',
    pagePaths: [],
    currentPageType: 'welcome'
}

const getters = {
    get: state => state.form,
    fieldComponents: state => state.fieldComponents,
    formPages: state => state.formPages,
    formData: state => state.formData,
    originalForm: state => state.originalForm,
    saveFormData: state => state.saveFormData,
    formFields: state => state.formFields,
    totalPages: state => state.totalPages,
    currentPage: state => state.currentPage,
    currentGroup: state => state.currentGroup,
    currentField: state => state.currentField,
    formFieldBlacklist: state => state.formFieldBlacklist,
    rulesModal: state => state.rulesModal,
    checkRulesTimeout: state => state.checkRulesTimeout,
    checkRulesTimeoutWait: state => state.checkRulesTimeoutWait,
    changingPage: state => state.changingPage,
    changingPageForward: state => state.changingPageForward,
    navigationActive: state => state.navigationActive,
    frontend: state => state.frontend,
    formReference: state => state.formReference,
    frontendData: state => state.frontendData,
    elementCount: state => state.elementCount,
    getExistingSignature: state => state.getExistingSignature,
    saveReusableSignature: state => state.saveReusableSignature,
    pagePaths: state => state.pagePaths,
    currentPageType: state => state.currentPageType
}

const mutations = {
    setForm(state, form) {
        state.form = form
    },
    setOriginalForm(state, form) {
        state.originalForm = form
    },
    setCurrentPage(state, currentPage) {
        state.currentPage = currentPage
    },
    setCurrentGroup(state, currentGroup) {
        state.currentGroup = currentGroup
    },
    setFieldComponents(state, fieldComponents) {
        state.fieldComponents = fieldComponents
    },
    setFormFields(state, formFields) {
        state.formFields = formFields
    },
    setFormPages(state, formObject) {

        let form = formObject.form
        let hasQuote = formObject.hasQuote

        if (!_.isEmpty(form.form_config.fields)) {
            let fieldObjects = form.form_config.fields.map((field) => {
                
                if (field.type === 'customField') {
                    field.component = state.fieldComponents[_.camelCase(field.fieldComponent.component.name)]
                } else if (field.type !== 'pageBreak') {
                    field.component = state.fieldComponents[_.camelCase(field.component.name)]
                }

                const subFieldFormPages = (subFields) => {
                    return subFields.map((sub) => {
                        if (sub.type === 'customField') {
                            sub.component = state.fieldComponents[_.camelCase(sub.fieldComponent.component.name)]
                        } else if (sub.type !== 'pageBreak') {
                            sub.component = state.fieldComponents[_.camelCase(sub.component.name)]
                        }
                        if (!_.isEmpty(sub.subFields)) {
                            sub.subFields = subFieldFormPages(sub.subFields)
                        }
                        return sub
                    })
                }
                if (!_.isEmpty(field.subFields)) {
                    field.subFields = subFieldFormPages(field.subFields)
                }
                return field
            })

            let formPages = []
            let currentPage = []
            let totalFields = _.size(fieldObjects)

            // first page is the welcome page
            if (!state.frontend) {
                formPages.push('welcome')
            }

            let applicationTypeId = _.get(state, 'formData.application.application_type_id')
            fieldObjects.forEach((formField, index) => {
                if (formField.type === "pageBreak") {
                    formPages.push(currentPage)
                    currentPage = []
                    if (formField.appType && Number(applicationTypeId) !== Number(formField.appType)) {
                        currentPage.push({
                            remove: true
                        })
                    }
                } else {
                    currentPage.push(formField)
                }
                
                if (totalFields === index + 1) {
                    if (formField.type !== "pageBreak") {
                        formPages.push(currentPage)
                        currentPage = []
                    }
                }
            })

            if (!state.frontend) {
                if (hasQuote) formPages.push('quote')
                formPages.push('final')
            }
            
            state.formPages = formPages.filter(formPage => {
                if (Array.isArray(formPage)) {
                    let first = _.first(formPage)
                    return !_.has(first, 'remove', false)
                } else {
                    return true
                }
            })

            state.totalPages = _.size(formPages)
        }
    },

    setFormData(state, formData) {
        state.formData = _.cloneDeep(formData)
    },

    setSaveFormData(state, formData) {
        state.saveFormData = _.cloneDeep(formData)
    },

    setRulesModal(state, groupField) {
        let rulesModal = {
            visible: false,
            path: "",
            group: {},
            title: "",
            message: "",
            ok: "",
            cancel: "",
            combined: false
        }
        if (_.has(groupField, 'ruleOptions', false) && !_.isEmpty(groupField.ruleOptions)) {

            let groupFieldData = Object.assign({}, groupField)

            rulesModal = {
                visible: groupFieldData.visible,
                path: groupFieldData.path,
                group: _.isEmpty(groupFieldData.name) ? groupFieldData.id : groupFieldData.name,
                title: groupFieldData.ruleOptions.title,
                message: groupFieldData.ruleOptions.message,
                ok: groupFieldData.ruleOptions.ok,
                cancel: groupFieldData.ruleOptions.cancel,
                combined: groupFieldData.ruleOptions.combined,
            }
        }

        state.rulesModal = rulesModal
    },
    setCurrentField(state, field) {
        state.currentField = field
    },
    setChangingPage(state, changingPage) {
        state.changingPage = changingPage
    },
    setChangingPageForward(state, changingPageForward) {
        state.changingPageForward = changingPageForward
    },
    setCheckRulesTimeout(state, rulesTimeout) {
        state.checkRulesTimeout = rulesTimeout
    },
    setCheckRulesTimeoutWait(state, rulesTimeoutWait) {
        state.checkRulesTimeoutWait = rulesTimeoutWait
    },
    setNavigationActive(state, status) {
        state.navigationActive = status
    },
    setFrontend(state, frontend) {
        state.frontend = frontend
    },
    setFormReference(state, reference) {
        state.formReference = reference
    },
    setFrontendData(state, data) {
        state.frontendData = data
    },
    setElementCount(state, count) {
        state.elementCount = count
    },
    setReusableSignature(state, saveReusableSignature) {
        state.saveReusableSignature = saveReusableSignature
    },
    setExistingSignature(state, getExistingSignature) {
        state.getExistingSignature = getExistingSignature
    },
    setPagePaths(state, pagePath) {
        if (_.isEmpty(pagePath)) {
            state.pagePaths = []
        } else {
            if (!state.pagePaths.includes(pagePath)) {
                state.pagePaths.push(pagePath)
            }
        }
    },
    setCurrentPageType(state, currentPageType) {
        state.currentPageType = currentPageType
    },
}

const actions = {
    set({commit, rootState}, form) {
        commit("setForm", form)
        commit("setOriginalForm", _.cloneDeep(form))
        commit("setFormFields", _.get(form, 'form_config.fields', []))
        commit("setFormPages", {
            form: form,
            hasQuote: rootState.formStore.core.core.hasQuote
        })
    },
    setFormPages({commit, rootState}, form) {
        let formData = typeof form !== "undefined" ? form : rootState.formStore.form.form
        commit("setFormPages", {
            form: formData,
            hasQuote: rootState.formStore.core.core.hasQuote
        })
    },
    setFormData({commit}, formData) {
        commit("setFormData", formData)
    },
    setSaveFormData({commit}, formData) {
        commit("setSaveFormData", formData)
    },
    setFieldComponents({commit}, fieldComponents) {
        commit("setFieldComponents", fieldComponents)
    },
    setCurrentPage({commit}, currentPage) {
        commit("setCurrentPage", currentPage)
    },
    setCurrentGroup({commit}, currentGroup) {
        commit("setCurrentGroup", currentGroup)
    },
    setRulesModal({commit}, group) {
        commit("setRulesModal", group)
    },
    setCurrentField({commit, dispatch}, field) {
        commit("setCurrentField", field)
        if (_.has(field, 'group.id', false) && !_.isNull(field.group.id) && _.has(field, 'group.description', false) && !_.isNull(field.group.description)) {
            dispatch("setCurrentGroup", field.group)
        }
    },
    setChangingPage({commit, dispatch}, changingPage) {
        commit("setChangingPage", changingPage)
    },
    setChangingPageForward({commit, dispatch}, changingPageForward) {
        commit("setChangingPageForward", changingPageForward)
    },
    setCheckRulesTimeout({commit, dispatch}, rulesTimeout) {
        commit("setCheckRulesTimeout", rulesTimeout)
    },
    setCheckRulesTimeoutWait({commit, dispatch}, rulesTimeoutWait) {
        commit("setCheckRulesTimeoutWait", rulesTimeoutWait)
    },
    setFormFields({commit, dispatch}, formFields) {
        commit("setFormFields", formFields)
    },
    setNavigationActive({commit, dispatch}, status) {
        commit("setNavigationActive", status)
    },
    setFrontend({commit, dispatch}, frontend) {
        commit("setFrontend", frontend)
    },
    setFormReference({commit, dispatch}, reference) {
        commit("setFormReference", reference)
    },
    setFrontendData({commit, dispatch}, data) {
        commit("setFrontendData", data)
    },
    setElementCount({ commit, dispatch }, count) {
        commit("setElementCount", count)
    },
    setReusableSignature({commit, dispatch}, saveReusableSignature) {
        commit("setReusableSignature", saveReusableSignature)
    },
    setExistingSignature({commit, dispatch}, getExistingSignature) {
        commit("setExistingSignature", getExistingSignature)
    },
    setPagePaths({commit, dispatch}, pagePath) {
        commit("setPagePaths", pagePath)
    },
    setCurrentPageType({commit, dispatch}, currentPageType) {
        commit("setCurrentPageType", currentPageType)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
